import { useQuery } from '@tanstack/react-query';
import * as masterMedicinesApi from '../../apis/master-medicines/requests';

export const useMasterMedicines = () => {
  const { data: masterMedicinesResponse, isFetched: isLoaded, refetch } = useQuery({
    queryKey: ['master-products'],
    queryFn: () => masterMedicinesApi.getMasterMedicines(0, 50),
    meta: { errorMessage: 'Failed to load master products list' }
  });

  const total = masterMedicinesResponse?.data.pagination?.total ?? 0;
  const masterMedicines = masterMedicinesResponse?.data.data || [];

  return {
    masterMedicines,
    isLoaded,
    total,
    refetch
  };
};
